import {
  MinimumVersionData,
  VersionSupportStatus,
} from '@/utils/minimum-version-types';

// OTA updates aren't used on web, so override the check
export const useAppMinimumVersion = (): MinimumVersionData => {
  return {
    appMinimumVersion: null,
    supportStatus: VersionSupportStatus.Supported,
  };
};
